import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  AppBar,
  IconButton,
  Snackbar,
  Toolbar,
} from '@mui/material';
import {
  ChevronLeft,
} from '@mui/icons-material';
import { Formik, Form } from 'formik';
import {SheetContext} from '../../context';
import {dateFormat} from '../../utils';
import StageAmount from './StageAmount';
import '../../styles/AddExchange.scss';

export function AddExchangeScreen({addFn, forceSnackOpen}) {
  let navigate = useNavigate();
  let [snackOpen, setSnackOpen] = useState(forceSnackOpen || false);

  const handleSnackClose = () => {
    setSnackOpen(false);
  };
  const onSubmit = (values, { setSubmitting }) => {
    setTimeout(async () => {
      // alert(JSON.stringify(values, null, 2));
      const date = new Date(values.date);
      const now = new Date();
      date.setHours(now.getHours());
      date.setMinutes(now.getMinutes());
      date.setSeconds(now.getSeconds());
      try {

        await addFn({
          date: date.getTime(),
          lbp: values.amountRes,
          usd: values.amountSrc,
        });
        setSubmitting(false);

        // navigate to expenses
        navigate('/exchanges');
      } catch(ex) {
        console.error(ex);
        setSubmitting(false);
        setSnackOpen(true);
      }
    }, 400);
  };
  const navigateBack = () => {
    navigate(-1);
  }

  const today = new Date(Date.now()).toISOString().substr(0, 10);
  return <div className="add-exchange-screen">
    <Formik
      initialValues={{ amountSrc: '0', amountRes: '0', currency: 'LBP', date: today, category: '', description: '' }}
      validate={values => {
        const errors = {};
        if (!values.amountSrc || isNaN(values.amountSrc) || values.amountSrc === '0') {
          errors.amountSrc = 'Required';
        }
        if (!values.amountRes || isNaN(values.amountRes) || values.amountRes === '0') {
          errors.amountRes = 'Required';
        }
        return errors;
      }}
      onSubmit={onSubmit}
    >
      {({ isSubmitting, submitForm, values, setFieldValue, touched, errors, handleChange }) => (
        <Form>
          <AppBar color="transparent" position="static">
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={navigateBack}
              >
                <ChevronLeft />
              </IconButton>
            </Toolbar>
          </AppBar>
          <StageAmount isSubmitting={isSubmitting} submitform={submitForm} values={values} setFieldValue={setFieldValue} />
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            key={'error-snack'}
          >
            <Alert
              onClose={handleSnackClose}
              severity="error"
              variant="filled"
              sx={{ width: '100%' }}
            >Could not save. Check connection and try again.</Alert>
          </Snackbar>
        </Form>
      )}
    </Formik>
  </div>
}
export default function AddExchangeScreenWrapper() {
  const ctx = useContext(SheetContext);
  const {addExchange} = ctx;

  return <AddExchangeScreen addFn={addExchange} />
}
